export default "__VITE_ASSET__d3e63cab__"